// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__13Tof","inputWrap":"styles_inputWrap__1J0_H","input":"styles_input__2vhuo"};